module.exports = __webpack_public_path__ + "img/new_shanghai.861646bc.png";